import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringEndWithExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringEndWithExpression";

export class StringEndWithExpressionEditor extends ExpressionRuleEditor<StringEndWithExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece>end with</ExpressionPiece>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
